import { render, staticRenderFns } from "./BrokerDetails.vue?vue&type=template&id=6ac7a418"
import script from "./BrokerDetails.vue?vue&type=script&lang=js"
export * from "./BrokerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports